import { Box, Avatar, Typography, IconButton } from '@mui/material';
import { Close, Check } from '@mui/icons-material';
import type { RewardRequest } from '../../types/dashboard';

interface RewardRequestItemProps {
  request: RewardRequest;
  onApprove: (id: string) => void;
  onReject: (id: string) => void;
}

const RewardRequestItem = ({ request, onApprove, onReject }: RewardRequestItemProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        py: 1.5
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Avatar
          src={request.avatar}
          alt={request.userName}
          sx={{ width: 40, height: 40 }}
        />
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              fontSize: '0.875rem'
            }}
          >
            {request.userName}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              fontSize: '0.75rem'
            }}
          >
            {request.rewardType}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <IconButton
          size="small"
          onClick={() => onReject(request.id)}
          sx={{
            width: 32,
            height: 32,
            backgroundColor: 'rgba(239, 68, 68, 0.1)',
            color: '#EF4444',
            '&:hover': {
              backgroundColor: 'rgba(239, 68, 68, 0.2)'
            }
          }}
        >
          <Close sx={{ fontSize: 16 }} />
        </IconButton>
        <IconButton
          size="small"
          onClick={() => onApprove(request.id)}
          sx={{
            width: 32,
            height: 32,
            backgroundColor: 'rgba(34, 197, 94, 0.1)',
            color: '#22C55E',
            '&:hover': {
              backgroundColor: 'rgba(34, 197, 94, 0.2)'
            }
          }}
        >
          <Check sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default RewardRequestItem;